export default __webpack_public_path__ + "static/media/dp-big--portfolio-08.905218e2.jpg";